import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import psswordLogo from '../../assests/images/passwordanimation.gif';

import { useHistory } from 'react-router-dom';

import "./style.scss";

const Modals = ({ show,
    handleClose,
    password,
    passwordError,
    handlePasswordChange,
    submitBTN
}) => {

    const history = useHistory();

    const handleRedirectToHome = () => {
        history.push('/');
    };

    if (!show) return null;

    return (
        <Modal show={show} onHide={handleClose} centered className="custom-modal adminPassword" backdrop="static">
             <Modal.Header>
                <button 
                    type="button" 
                    className="btn-close" 
                    aria-label="Close" 
                    onClick={handleRedirectToHome}
                >
                    &times;
                </button>
            </Modal.Header>
            <Modal.Body>

                <img src={psswordLogo} alt="alert" className='git' />

                {<div className='changePawword-outer'>
                    {/* <SectionTitle title={'Reset Password'}>  Reset Password</SectionTitle> */}

                    <div className="row mb-50 mb-bottom-30 d-flex justify-content-center">
                        <div className='stat-body clearfix d-flex flex-column justify-content-center align-items-center'>
                            <div className="form-group">
                                <p htmlFor="password">Kindly Enter Your Admin Password</p>
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    placeholder="Enter Password"
                                    // id='password'
                                    value={password}
                                    className="form-control mt-2"
                                    onChange={handlePasswordChange}
                                    autoComplete="new-password"
                                />
                                {passwordError && <div className="text-danger">{passwordError}</div>}
                            </div>
                            <button type="button" className="btn btn-primary" onClick={submitBTN}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>}
            </Modal.Body>

        </Modal>
    );
};

export default Modals;
